import { FormikHandlers } from 'formik'
import React from 'react'

interface SelectDropdownProps {
  additionalContainerClasses?: string
  defaultValue?: string
  disabled?: boolean
  error?: string
  font?: string
  handleBlur: FormikHandlers['handleBlur']
  handleChange: FormikHandlers['handleChange']
  id?: string
  labelText: string
  marginBottom?: string
  name?: string
  options: { text: string; value: string; disabled?: boolean }[]
  placeholder: string
  required?: boolean
  showDefaultOption?: boolean
  tooltip?: React.ReactNode
  touched?: boolean
  value: string
  width?: string
}

const SelectDropdown: React.FC<SelectDropdownProps> = ({
  additionalContainerClasses = '',
  disabled,
  error,
  font,
  handleBlur,
  handleChange,
  id,
  labelText,
  marginBottom = 'mb-2',
  name,
  options,
  placeholder = 'Select',
  required,
  showDefaultOption = false,
  tooltip,
  touched,
  value,
  width = 'w-full',
}) => {
  const hasError = Boolean(touched && error)

  return (
    <div
      className={`flex relative flex-col ${additionalContainerClasses} ${width} ${marginBottom}`}
    >
      <label
        htmlFor={id ? id : undefined}
        className={`flex items-center gap-1 text-sm text-gray-copy mb-[6px] ${
          font ? font : ''
        }`}
      >
        <span>
          {labelText} {required && <span className="">*</span>}
        </span>
        {tooltip}
      </label>
      <select
        aria-describedby={`${id}_hint`}
        aria-invalid={hasError ? 'true' : 'false'}
        name={name ? name : undefined}
        id={id ? id : undefined}
        value={value}
        disabled={disabled}
        onBlur={handleBlur}
        onChange={handleChange}
        className={`rounded-md ${
          hasError
            ? 'border-red-brand focus:ring-red-brand'
            : 'border-[#BDBDBD] focus:ring-nptDGreen'
        } focus:outline-none focus:ring-2 focus:ring-offset-2 transition-all duration-300 text-sm disabled:bg-gray-100 disabled:border-gray-400`}
      >
        <option
          value=""
          disabled={showDefaultOption}
          hidden={!showDefaultOption}
        >
          {placeholder}
        </option>
        {options.map((option, index) => (
          <option
            key={`${option.value}-${index}`}
            value={option.value}
            disabled={option.disabled}
          >
            {option.text}
          </option>
        ))}
      </select>

      {hasError && (
        <p
          id={id ? `${id}_hint` : undefined}
          className={`${
            !error ? 'hidden opacity-0' : 'opacity-100'
          } absolute top-full left-0 mt-1 max-w-[270px] text-xs text-red-brand`}
        >
          {error}
        </p>
      )}
    </div>
  )
}

export default SelectDropdown
